import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const swiperSlides = () => {
  new Swiper('.swiper-gallery', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,
    speed: 600,
    grabCursor: true,
    breakpoints: {
      320: {
        slidesPerView: 1.08,
        spaceBetween: 10,
      },
      1440: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
    },
  });
};
export default swiperSlides;
